import { observer } from "mobx-react-lite";
import React, { ReactElement, SyntheticEvent, useState } from "react";
import { Button, Grid, Header, Icon, Label, Modal, Segment, Step, TabPane} from "semantic-ui-react";
import { IAssessment } from "../../Models/Assessment";
import { ModuleOverviewHeader } from "./ModuleOverviewHeader";
import { DocumentLibrary } from "../../Components/Assessment/Documents/DocumentLibrary";
import { headerNavigation as topNav } from '../../Components/Enums/NavigationEnums';
import styles from './ModuleOverviewModal.module.css';
import RenderResources from "../../Components/Assessment/Resources/RenderResources";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const ModuleOverviewModal: React.FC<{
  hideOverview: () => void;
  overviewBody?: ReactElement<any, any>;
  tasks: any[];
  assessment: IAssessment;
  domain: string;
  taskIndex: number;
  caregiverId: string;
  selectedRecipientId: string;
  selectedRecipientName: string;
  setTaskChecklistToVisible: () => void;
  setAssessmentToVisible: () => void;
  setAssessmentHidden: () => void;
  setTaskIndex: (idx: any) => void;
  setTaskTitle: (title: string) => void;
}> = ({
  hideOverview,
  overviewBody,
  tasks,
  assessment,
  domain,
  taskIndex,
  caregiverId,
  selectedRecipientId,
  selectedRecipientName,
  setTaskChecklistToVisible,
  setAssessmentToVisible,
  setTaskIndex,
  setTaskTitle,
}) => {
  const [activeHeaderTab, setActiveHeaderTab] = useState(topNav.OVERVIEW);

  const menuNavigationEvent = (name: any) => { 
    setActiveHeaderTab(name);
  }
  const onContinueClickHandler = (idx: number, data: any|object) => {
    var idxUpdatedVal = idx;
    if(idx < 0) { idxUpdatedVal = data.id }
    setTaskIndex(idxUpdatedVal);
    setAssessmentToVisible();
    setTaskTitle(tasks[idxUpdatedVal].taskName);
  };

  const onViewTaskChecklistClickHandler = () => {setTaskChecklistToVisible();};


  const stepLabels = tasks.map( (x, index) => {
    return {key: index,
            id: index,
            index: index,
            className: styles.overviewTaskListStep,
            onClick: (event: SyntheticEvent, data: object) => onContinueClickHandler(-1, data ),
            title: {
              className: styles.overviewTaskListStepTitle,
              content: <Label ribbon="right" id={styles.overviewTaskListRibbon} className={`${styles.overviewTaskListRibbon} ${(x.isAnswered ? styles.overviewTaskListRibbonCompleted : styles.overviewTaskListRibbonIncomplete)}`}>
                          {x.taskName} 
                          <Icon key={index} name={x.isAnswered ? 'check' : 'square outline'} className={`${styles.overviewTaskListIconLabel} ${(x.isAnswered ? styles.overviewTaskListIconLabelCompleted : "")}`} /> 
                       </Label> },
      
          };
  });
  
  return (
    <Modal open={true} id={styles.overviewModalHeader}>
      <Segment.Group className={styles.overviewModalHeaderUi}>
        <ModuleOverviewHeader
          hideAssessment={hideOverview}
          domain={domain}
          assessment={assessment}
          activeTab={activeHeaderTab}
          menuNavigationEvent={menuNavigationEvent}
        />

        <Segment attached id={styles.overviewModalContent} >
          {/* Overview */}
          <TabPane active={activeHeaderTab === topNav.OVERVIEW} id={styles.overviewFullWidthHeight} >
            <Grid columns={2} stackable reversed="computer" id={styles.overviewFullWidthHeight} >
              <Grid.Row stretched verticalAlign="top" id={styles.overviewFullWidthHeight} >
                {/* TaskList */}
                <Grid.Column floated="left" width={5} id={styles.taskListFullWidthHeight} >
                  <Header as={"h2"} id={styles.overviewTaskListHeader}>Tasks to Complete</Header>
                  <Step.Group fluid vertical id={styles.overviewTaskListStepGroup} items={stepLabels} />
                </Grid.Column>          
                {/* Overview Body */}
                <Grid.Column floated="right" width={11} id={styles.overviewGridColumn}>{overviewBody}</Grid.Column>        
              </Grid.Row>
            </Grid>
          </TabPane> 
          {/* Resources */}
          <TabPane active={activeHeaderTab === topNav.RESOURCES} id={styles.overviewFullWidthHeight} >
            <Segment basic id={styles.imgResourceBG} style={{ backgroundImage: `url(${cdnRoute}Paper-Texture-BG.jpg)`, }}>
              <Segment basic className={styles.segmentTabWithBGImg} >
                <RenderResources domain={domain} areInfoSlidesComplete={false} infoSlideIndex={0} assessment={null}/>
              </Segment>
            </Segment>
          </TabPane>
          {/* Documents */}
          <TabPane active={activeHeaderTab === topNav.DOCUMENTS} id={styles.overviewFullWidthHeight} >
            <DocumentLibrary domain={domain} caregiverId={caregiverId}  recipientId={selectedRecipientId} recipientName={selectedRecipientName} />
          </TabPane>
        </Segment>
        
        <Segment clearing attached='bottom' id={styles['medicalOverviewCta']}>
          <Button floated="left" onClick={() => onViewTaskChecklistClickHandler()}  id={styles.backButton} > View Task Checklist </Button>

          <div className={`${styles.buttonGrpWrapper}`} >
            <div className={`small ui basic buttons ${styles.tabButtonGroup}`} >
              <div onClick={() => setActiveHeaderTab(topNav.RESOURCES)} className={`small ui button ${styles.tabButton}`} >Resources</div>
              <div onClick={() => setActiveHeaderTab(topNav.DOCUMENTS)} className={`small ui button ${styles.tabButton}`} >Documents</div>
            </div>
          </div>
          <Button floated="right" onClick={(event: SyntheticEvent, data: object) => onContinueClickHandler(taskIndex, data)} id={styles.continueButton} > Continue </Button>
        </Segment>
      </Segment.Group>
    </Modal>
  );    
};

export default observer(ModuleOverviewModal);
